"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setDistinctIdCookie = exports.getDistinctIdCookie = void 0;
const deep_equal_1 = __importDefault(require("deep-equal"));
const Storage_1 = __importDefault(require("./Storage"));
const request_1 = __importDefault(require("./request"));
/**
 * Default axe server host.
 */
const DEFAULT_HOST = 'https://axe.deque.com';
/**
 * Default request origin.
 */
/* istanbul ignore next */
const DEFAULT_ORIGIN = (_a = globalThis.location) === null || _a === void 0 ? void 0 : _a.origin;
/**
 * Default storage key.
 */
const LOCAL_STORAGE_KEY = 'distinct_id';
/**
 * Create our storage instance.
 */
const storage = new Storage_1.default();
/**
 * Get the Distinct ID cookie associated with the current user.
 */
const getDistinctIdCookie = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (params = {}) {
    const isLoggedIn = !!params.token;
    const { key = LOCAL_STORAGE_KEY, host = DEFAULT_HOST, origin = DEFAULT_ORIGIN } = params;
    // Get the values from storage.
    const localCookie = ((yield storage.get(key)) || {});
    const localDistinctId = localCookie.distinct_id;
    const localKeyCloakId = localCookie.keycloak_id;
    // Get the values from the server.
    const remoteCookie = (yield (0, request_1.default)({
        method: 'GET',
        host,
        origin,
        token: params.token
    })) || {};
    const remoteDistinctId = remoteCookie.distinct_id;
    const remoteKeyCloakId = remoteCookie.keycloak_id;
    // If the IDs are set AND match, return what was stored. There's nothing left to do.
    if (localDistinctId &&
        localDistinctId === remoteDistinctId &&
        localKeyCloakId &&
        localKeyCloakId === remoteKeyCloakId &&
        (0, deep_equal_1.default)(remoteCookie.data, localCookie.data)) {
        return localCookie;
    }
    // The cookie we'll set (POST to the server and/or persist in local storage).
    const cookie = {
        // so this is never undefined
        distinct_id: ''
    };
    if (!remoteDistinctId && !localDistinctId) {
        // Neither localStorage nor the cookie had the ID. We generate a new ID, set it in localStorage and attempt to set the cookie.
        cookie.distinct_id = crypto.randomUUID();
        cookie.keycloak_id = remoteKeyCloakId || localKeyCloakId;
        if (remoteKeyCloakId === localKeyCloakId || !localKeyCloakId) {
            // merge
            cookie.data = Object.assign(Object.assign({}, localCookie.data), remoteCookie.data);
        }
        else {
            // overwrite
            cookie.data = remoteCookie.data;
        }
        return (0, exports.setDistinctIdCookie)(cookie, params);
    }
    if (remoteDistinctId) {
        if (!remoteKeyCloakId) {
            if (isLoggedIn) {
                // logged in without remote Keycloak ID
                // all we need to do is resolve conflicts in data and post back
                cookie.distinct_id = remoteDistinctId;
                if (localDistinctId !== remoteDistinctId) {
                    cookie.data = remoteCookie.data;
                }
                else {
                    cookie.data = Object.assign(Object.assign({}, localCookie.data), remoteCookie.data);
                }
                // Post differences back to server
                return (0, exports.setDistinctIdCookie)(cookie, params);
            }
            if (!localDistinctId) {
                cookie.distinct_id = remoteDistinctId;
                cookie.data = Object.assign(Object.assign({}, localCookie.data), remoteCookie.data);
                if ((0, deep_equal_1.default)(cookie.data, remoteCookie.data)) {
                    yield storage.set(key, cookie);
                    return cookie;
                }
                // Post differences back to server
                return (0, exports.setDistinctIdCookie)(cookie, params);
            }
            if (localDistinctId !== remoteDistinctId) {
                // overwrite local storage
                yield storage.set(key, remoteCookie);
                return remoteCookie;
            }
            if (localKeyCloakId) {
                // merge cookies for post to server
                cookie.keycloak_id = localKeyCloakId;
                cookie.distinct_id = localDistinctId;
                cookie.data = Object.assign(Object.assign({}, localCookie.data), remoteCookie.data);
                // Post differences back to server
                return (0, exports.setDistinctIdCookie)(cookie, params);
            }
            cookie.distinct_id = remoteDistinctId;
            cookie.data = Object.assign(Object.assign({}, localCookie.data), remoteCookie.data);
            if ((0, deep_equal_1.default)(cookie.data, remoteCookie.data)) {
                yield storage.set(key, cookie);
                return cookie;
            }
            // Post differences back to server
            return (0, exports.setDistinctIdCookie)(cookie, params);
        }
        // cookie has both distinct_id and keycloak_id
        if (localDistinctId && remoteDistinctId !== localDistinctId) {
            if (remoteKeyCloakId !== localKeyCloakId) {
                // overwrite everything with the cookie
                yield storage.set(key, remoteCookie);
                return remoteCookie;
            }
        }
        // merge the data
        cookie.distinct_id = remoteDistinctId;
        cookie.keycloak_id = remoteKeyCloakId;
        cookie.data = Object.assign(Object.assign({}, localCookie.data), remoteCookie.data);
        if ((0, deep_equal_1.default)(cookie.data, remoteCookie.data)) {
            yield storage.set(key, cookie);
            return cookie;
        }
        // Post differences back to server
        return (0, exports.setDistinctIdCookie)(cookie, params);
    }
    // cookie has no distinct_id, we need to always post
    if (!remoteKeyCloakId || remoteKeyCloakId === localKeyCloakId) {
        // We know this (the local ID) is a string at this point.
        cookie.distinct_id = localDistinctId;
        cookie.keycloak_id = localKeyCloakId; // does not matter if it does not match, the server will nuke it
        cookie.data = Object.assign(Object.assign({}, localCookie.data), remoteCookie.data);
    }
    else {
        cookie.distinct_id = crypto.randomUUID();
        cookie.keycloak_id = remoteKeyCloakId;
        cookie.data = remoteCookie.data;
    }
    return (0, exports.setDistinctIdCookie)(cookie, params);
});
exports.getDistinctIdCookie = getDistinctIdCookie;
/**
 * Get the Distinct ID associated with the current user.
 */
const getDistinctId = (...args_1) => __awaiter(void 0, [...args_1], void 0, function* (params = {}) {
    const cookie = yield (0, exports.getDistinctIdCookie)(params);
    return cookie.distinct_id;
});
exports.default = getDistinctId;
/**
 * Set the distinct ID associated with the current user.
 */
const setDistinctIdCookie = (cookie_1, ...args_1) => __awaiter(void 0, [cookie_1, ...args_1], void 0, function* (cookie, { 
// istanbul ignore next
key = LOCAL_STORAGE_KEY, 
// istanbul ignore next
host = DEFAULT_HOST, 
// istanbul ignore next
origin = DEFAULT_ORIGIN, token } = {}) {
    yield storage.set(key, cookie);
    yield (0, request_1.default)({
        method: 'POST',
        host,
        origin,
        token,
        payload: cookie
    });
    return cookie;
});
exports.setDistinctIdCookie = setDistinctIdCookie;
//# sourceMappingURL=getDistinctId.js.map